module.exports = __webpack_public_path__ + "assets/total_conversions.1f079ca9.svg";